import React from 'react';

const Security = () => {
  return (
    <div>
      <h2 className="page-title">Security</h2>
      <div className="card">
        <h3 style={{ marginTop: 0 }}>Coming Soon</h3>
        <p className="helper">
          The Security module will provide comprehensive security monitoring,
          threat detection, audit logs, and compliance management.
        </p>
      </div>
    </div>
  );
};

export default Security;
